module.exports = __webpack_public_path__ + "static/img/jpcomma.bd846763.png";